import type { ReactNode } from "react";
import { HatTooltip } from "@/components/tooltip";
import type { DatasetMatchMode } from "./labelFilterQuery";
import styles from "./DatasetFilter.module.css";

// 조합 방식 문구의 유일한 소유자다. 레일 배지 툴팁, 고급 필터 시트 힌트, 세그먼트 툴팁이 함께 쓴다.
// 시트도 이 값을 import 한다. 방향이 시트 → DatasetFilter → MatchModeChip 이라서 순환 import 가 없다.
export const combineHints: Record<DatasetMatchMode, string> = {
  all: "선택한 모든 필터와 검색어를 동시에 만족하는 Dataset만 표시합니다. 대부분의 탐색에 적합한 기본값입니다.",
  any: "선택한 필터 중 하나라도 만족하면 표시합니다. 검색어와 상태 조건은 항상 함께 적용됩니다. 폭넓게 훑어볼 때 사용해 보세요.",
};

const chipLabels: Record<DatasetMatchMode, string> = {
  all: "AND 일치",
  any: "OR 일치",
};

// 클릭하면 전환될 반대 모드의 안내다. aria-label 과 툴팁이 함께 쓴다.
const toggleHints: Record<DatasetMatchMode, string> = {
  all: "누르면 하나라도 만족(OR)으로 전환합니다.",
  any: "누르면 모두 만족(AND)으로 전환합니다.",
};

export type MatchModeChipProps = {
  mode: DatasetMatchMode;
  disabled: boolean;
  onToggle: () => void;
};

// 필터 레일의 조합 방식 배지 칩이다. 조건이 2개 이상이라 AND/OR 에 따라 결과가 다를 때만
// 페이지가 렌더한다. 표시 판정은 countFilterPredicates + 라벨 토큰 수이고, DatasetFilter 가 소유한다.
// 클릭하면 두 모드를 번갈아 바꾸는 스위치다. 그래서 aria-pressed(on/off 의미)를 쓰지 않고,
// 현재 상태와 동작을 aria-label 로 설명한다.
export function MatchModeChip({ mode, disabled, onToggle }: MatchModeChipProps): ReactNode {
  return (
    <HatTooltip content={`${combineHints[mode]} ${toggleHints[mode]}`} placement="bottom">
      <button
        type="button"
        className={styles.matchModeChip}
        disabled={disabled}
        aria-label={`필터 조합 방식: ${chipLabels[mode]}. ${toggleHints[mode]}`}
        onClick={onToggle}
      >
        {chipLabels[mode]}
      </button>
    </HatTooltip>
  );
}
